// Removed direct store import to avoid circular dependency
import { logout } from '@/store/feature/auth/authSlice';

class SessionManager {
  private static instance: SessionManager;
  private sessionExpiredCallback: (() => void) | null = null;
  private store: any = null; // Store reference injected at runtime

  private constructor() { }

  static getInstance(): SessionManager {
    if (!SessionManager.instance) {
      SessionManager.instance = new SessionManager();
    }
    return SessionManager.instance;
  }

  // Inject store to break circular dependency
  setStore(store: any) {
    this.store = store;
  }

  setSessionExpiredCallback(callback: (() => void) | null) {
    this.sessionExpiredCallback = callback;
  }

  handleSessionExpired() {
    // Clear tokens and filter-related data
    if (typeof window !== "undefined") {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("case-list-advanced-filters");
      localStorage.removeItem("line-listing-advanced-filters");
      localStorage.removeItem("duplicateSearchResults");
      localStorage.removeItem("duplicateSearchFields");
    }

    // Remove cookies
    if (typeof document !== "undefined") {
      document.cookie = "access_token=; Max-Age=0; path=/;";
      document.cookie = "refresh_token=; Max-Age=0; path=/;";
    }

    // Dispatch logout action (this will also reset filter state via extraReducers)
    if (this.store) {
      this.store.dispatch(logout());
    } else {
      console.warn("SessionManager: Store not injected, cannot dispatch logout action.");
    }

    // Call the callback to show modal
    if (this.sessionExpiredCallback) {
      this.sessionExpiredCallback();
    } else {
      // Fallback to direct navigation
      if (typeof window !== "undefined") {
        window.location.href = '/login';
      }
    }
  }
}

export default SessionManager;
